var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56934 11.4962C5.47214 11.4977 5.3757 11.4788 5.28617 11.441C5.19665 11.4031 5.11599 11.347 5.04934 11.2762L0.21934 6.53622C0.0788894 6.39559 0 6.20497 0 6.00622C0 5.80747 0.0788894 5.61684 0.21934 5.47622C0.362905 5.33752 0.554722 5.26 0.75434 5.26C0.953958 5.26 1.14578 5.33752 1.28934 5.47622L5.57934 9.70622L15.2293 0.216218C15.3729 0.077522 15.5647 0 15.7643 0C15.964 0 16.1558 0.077522 16.2993 0.216218C16.4398 0.356843 16.5187 0.547467 16.5187 0.746217C16.5187 0.944968 16.4398 1.13559 16.2993 1.27622L6.11934 11.2762C6.04776 11.3488 5.96196 11.4058 5.86731 11.4437C5.77267 11.4815 5.67122 11.4994 5.56934 11.4962Z",
    fill: "#00BC7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.480f88bccfac643f297f085de2b344da.svg";
export { ForwardRef as ReactComponent };